/**
 * Generated by orval v8.4.0 🍺
 * Do not edit manually.
 * corev2 platform admins
 * Platform-admin accounts on corev2. The browser sends the HttpOnly cookie token. Headers x-gbooking-userid and x-gbooking-token are accepted when the cookie is absent.

 * OpenAPI spec version: 0.1.0
 */
import * as zod from "zod"

/**
 * @summary List platform accounts except the caller
 */
export const PlatformAdminslistPlatformAdminsResponse = zod.object({
	items: zod
		.array(
			zod.object({
				id: zod.string(),
				name: zod.string(),
				email: zod.string().nullish(),
				roles: zod
					.array(zod.string())
					.describe(
						"platform_access, superuser, or both. Business roles are omitted.",
					),
			}),
		)
		.describe("Platform accounts other than the caller."),
	self: zod
		.object({
			id: zod.string(),
			name: zod.string(),
			email: zod.string().nullish(),
			roles: zod
				.array(zod.string())
				.describe(
					"platform_access, superuser, or both. Business roles are omitted.",
				),
		})
		.optional()
		.describe(
			"The caller. Not part of items. Editing this account is a separate screen.",
		),
})

/**
 * @summary Create an account whose only role is platform_access
 */
export const platformAdminscreatePlatformAdminBodyPasswordMin = 8

export const PlatformAdminscreatePlatformAdminBody = zod.object({
	name: zod.string(),
	email: zod.string(),
	password: zod.string().min(platformAdminscreatePlatformAdminBodyPasswordMin),
})

export const PlatformAdminscreatePlatformAdminResponse = zod.object({
	id: zod.string(),
	created: zod.boolean(),
})

/**
 * @summary Change name, email, or open/close platform_access (disabled on ACL)
 */
export const PlatformAdminsupdatePlatformAdminParams = zod.object({
	id: zod.string(),
})

export const PlatformAdminsupdatePlatformAdminBody = zod
	.object({
		name: zod.string().optional(),
		email: zod.string().optional(),
		enabled: zod.boolean().optional(),
	})
	.describe(
		"name and email require a superuser. enabled is available to any platform admin. password is rejected.",
	)

export const PlatformAdminsupdatePlatformAdminResponse = zod.object({
	id: zod.string(),
	name: zod.string().optional(),
	email: zod.string().nullish(),
	enabled: zod.boolean().optional(),
})
